/*
 * @Description:
 * @Autor: zwcong
 * @Date: 2021-12-01 10:47:41
 * @LastEditors: wangyan1 wangyan1
 * @LastEditTime: 2023-11-08 15:24:06
 */
import TkSdk from '@aixuexi/tksdk'
import '@aixuexi/tksdk/build/main.css'
import cookies from './cookies'
const tkSdkNew = new TkSdk()
const handleUrlParams = url => {
  if (typeof url !== 'string') {
    return null
  }
  const [, queryStr] = url.split('?')

  const res = {}
  if (typeof queryStr === 'string') {
    queryStr.split('&').forEach(i => {
      const arr = i.split('=')
      const [key, value] = arr
      res[key] = value
    })
  }
  return res
}
// 计算两个时间之间的时间差 多少天时分秒
const intervalTime = startTime => {
  const current = new Date().getTime() // 结束时间
  const differ = current - startTime
  let minutes = parseInt(differ / (60 * 1000))
  minutes = String(minutes).length >= 2 ? minutes : `0${minutes}`
  let seconds = parseInt((differ) / 1000) % 60
  seconds = String(seconds).length >= 2 ? seconds : `0${seconds}`
  return minutes + ':' + seconds
}
const optionsSort = function(value) {
  return String.fromCharCode(parseInt(value) + 65)
}

// 解析公式
const onMathJax = async() => {
  tkSdkNew.runMathjax()
}

const colatex2svg = (data, size, color) => // 公式解析 size 公式字号大小number color 颜色值 string css颜色值如#ff000格式
  tkSdkNew.colatex2svg(tkSdkNew.imgWH(data), size, color)

const isAndroid = () => {
  const device = navigator.userAgent
  const isAndroid = device.indexOf('Android') > -1 || device.indexOf('Adr') > -1 // android终端
  return isAndroid
}

const platform = () => {
  let pf = ''
  const ua = navigator.userAgent
  if (/(iPhone|iPad|iPod|iOS)/i.test(ua)) {
    pf = PLATFORMS.IOS
  } else if (/(Android)/i.test(ua)) {
    pf = PLATFORMS.ANDROID
  } else {
    pf = PLATFORMS.OTHERS
  }

  return pf
}

const PLATFORMS = {
  IOS: 'iOS',
  ANDROID: 'android',
  OTHERS: 'others'
}

// loginSystem
// const TOKEN_NAME = 'ptxkhtpc'
const TOKEN_NAME = 'ptpc'

const getUserId = () => cookies.getItem(`${TOKEN_NAME}UserId`)

const getToken = () => cookies.getItem(TOKEN_NAME)
// const removeToken = () => cookies.clear(TOKEN_NAME)
const removeToken = () => {
  cookies.clear()
  cookies.clearKey(TOKEN_NAME)
}

export {
  handleUrlParams,
  intervalTime,
  optionsSort,
  onMathJax,
  isAndroid,
  platform,
  PLATFORMS,
  tkSdkNew,
  colatex2svg,
  TOKEN_NAME,
  getUserId,
  getToken,
  removeToken
}